const PINE_TREE_VARIANTS = {
  back: {
    scale: 0.75,
    trunkHeight: 2,
    trunkWidth: 1,
  },
  fore: {
    scale: 1,
    trunkHeight: 3,
    trunkWidth: 2,
  },
} as const;

type PineTreeProps = {
  baseX: number;
  baseY: number;
  variant?: keyof typeof PINE_TREE_VARIANTS;
};

function PineTree({ baseX, baseY, variant = "fore" }: PineTreeProps) {
  const { scale, trunkHeight, trunkWidth } = PINE_TREE_VARIANTS[variant];

  return (
    <g
      className={`pine-tree pine-tree-${variant}`}
      transform={`translate(${baseX} ${baseY}) scale(${scale})`}
    >
      <rect className="pine-trunk" height={trunkHeight} width={trunkWidth} x="0" y="0" />
      <rect className="pine-needle pine-needle-dark" height="1" width="1" x="0" y="-9" />
      <rect className="pine-needle pine-needle-dark" height="2" width="3" x="-1" y="-8" />
      <rect className="pine-needle pine-needle-mid" height="2" width="5" x="-2" y="-6" />
      <rect className="pine-needle pine-needle-light" height="2" width="7" x="-3" y="-4" />
      <rect className="pine-needle pine-needle-mid" height="2" width="5" x="-2" y="-2" />
    </g>
  );
}

export { PineTree };
